import { render, staticRenderFns } from "./PrivacyPolicies.vue?vue&type=template&id=59df6de1&"
import script from "./PrivacyPolicies.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicies.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicies.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports